var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-table-cell" }, [
    _c(
      "div",
      { staticClass: "c-table__cell-value" },
      [
        _c("candidates-source-icon", {
          attrs: { "source-id": _vm.data.source.id },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }